module.exports = __webpack_public_path__ + "static/media/DirectorAnushka.626dd436.jpeg";